import Vue from 'vue'
import Router from 'vue-router'
// import menuModule from '@/store/modules/menu';
import store from '../store';

const defaultcontainer = () => import('@/containers/defaultcontainer');
const login = () => import('@/wam/views/login');
const logout = () => import('@/wam/views/logout');
const register_approve = () => import('@/wam/views/register_approve');

Vue.use(Router)

// console.log('store : ', store);

function f_getSideBarMenu() {
  let route_list = [];
  // while (1) {
  //   let StoreMenuData = store.getters.StoreMenuData;
  //   if (StoreMenuData && StoreMenuData.data && StoreMenuData.data.list && StoreMenuData.data.list.length > 0) {
  //     // console.log('StoreMenuData : ', StoreMenuData);
  //     for (let i in StoreMenuData.data.list) {
  //       // console.log('StoreMenuData.data.list[i].route_path : ', StoreMenuData.data.list[i].route_path);
  //       if (StoreMenuData.data.list[i].route_path) {
  //         const new_item = {
  //           'path': StoreMenuData.data.list[i].route_path,
  //           'component': () => import('../views/pages/' + StoreMenuData.data.list[i].route_name),
  //           'name': StoreMenuData.data.list[i].route_name
  //         };
  //         route_list.push(new_item);
  //       }
  //       if (StoreMenuData.data.list[i].list && StoreMenuData.data.list[i].list.length > 0) {
  //         for (let sub_i in StoreMenuData.data.list[i].list) {
  //           if (StoreMenuData.data.list[i].list[sub_i].route_path) {
  //             const new_item = {
  //               'path': StoreMenuData.data.list[i].list[sub_i].route_path,
  //               'component': () => import('../views/pages/' + StoreMenuData.data.list[i].list[sub_i].route_name),
  //               'name': StoreMenuData.data.list[i].list[sub_i].route_name
  //             };
  //             route_list.push(new_item);
  //           }
  //         }

  //       }
  //     }
  //     break;
  //   }
  // }
  // console.log('_menu.website_data.routes.dashboard.path : ', _menu.website_data.routes.dashboard.path);
  // console.log(route_list);
  return route_list;
}

/*
export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
      path: '/',
      redirect: _menu.website_data.routes.dashboard.path,
      name: 'defaultcontainer',
      component: defaultcontainer,
      children: [
        ...f_getSideBarMenu(),
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/logout',
      name: 'logout',
      component: logout,
    }
  ]
})
*/